import Overlay from 'ol/Overlay';
import { map } from './Map.js';

let sharePinOverlay = null;

function ensureSharePin() {
  if (sharePinOverlay) return sharePinOverlay;

  const el = document.createElement('div');
  el.className = 'gp-pin-wrap';
  el.innerHTML = `
  <button class="gp-pin-close" title="إغلاق">
    <svg viewBox="0 0 24 24" width="12" height="12" stroke="white" stroke-width="3" fill="none" stroke-linecap="round" stroke-linejoin="round">
      <line x1="18" y1="6" x2="6" y2="18"></line>
      <line x1="6" y1="6" x2="18" y2="18"></line>
    </svg>
  </button>
  <div class="gp-pin"></div>
`;

  sharePinOverlay = new Overlay({
    element: el,
    positioning: 'bottom-center',
    stopEvent: true
  });

  el.querySelector('.gp-pin-close').addEventListener('click', () => {
    clearSharePin(true);
  });

  map.addOverlay(sharePinOverlay);
  return sharePinOverlay;
}

export function clearSharePin(removeUrlParams = false) {
  if (sharePinOverlay) sharePinOverlay.setPosition(undefined);
  if (removeUrlParams) {
    const url = new URL(location.href);
    url.searchParams.delete('x');
    url.searchParams.delete('y');
    url.searchParams.delete('z');
    history.replaceState({}, '', url);
  }
}

export function setSharePin(coord, { timeoutMs = 0, autoHide = false } = {}) {
  const ov = ensureSharePin();
  ov.setPosition(coord);

  if (autoHide && timeoutMs > 0) {
    const view = map.getView();
    const vp = map.getViewport();
    const opt = { once: true };

    const clearOnce = () => {
      clearSharePin(false);
      vp.removeEventListener('pointerdown', clearOnce, opt);
      vp.removeEventListener('wheel', clearOnce, opt);
      view.un('change:center', clearOnce);
      view.un('change:resolution', clearOnce);
    };

    vp.addEventListener('pointerdown', clearOnce, opt);
    vp.addEventListener('wheel', clearOnce, opt);
    view.on('change:center', clearOnce);
    view.on('change:resolution', clearOnce);
    setTimeout(clearOnce, timeoutMs);
  }
}

const params = new URLSearchParams(location.search);
if (params.has('x') && params.has('y')) {
  const px = Number(params.get('x'));
  const py = Number(params.get('y'));
  const pz = Number(params.get('z'));
  if (!isNaN(px) && !isNaN(py)) {
    map.getView().setCenter([px, py]);
    if (!isNaN(pz)) map.getView().setZoom(pz);
    setSharePin([px, py]);
  }
}
